import { handleActions } from 'redux-actions';
import { API_KEY_DIALOG_CLOSE, API_KEY_DIALOG_OPEN, API_KEY_DOWNLOAD, CAPS } from '../constants';

const init = {
  isDialogOpen: false,
  isApiKeyDownloadedBannerShown: false,
  loadingCredentials: false,
  elements: [],
  generatingCredentials: false,
  userName: null,
  password: null,
};

export default handleActions(
  {
    [API_KEY_DIALOG_CLOSE]: state => {
      return {
        ...state,
        isDialogOpen: false,
      };
    },
    [API_KEY_DIALOG_OPEN]: state => {
      return {
        ...state,
        isDialogOpen: true,
      };
    },
    [API_KEY_DOWNLOAD]: state => state,
    [CAPS.MERCHANTS_CREDENTIALS_GET.LOADING]: state => ({
      ...state,
      loadingCredentials: true,
      elements: [],
    }),
    [CAPS.MERCHANTS_CREDENTIALS_GET]: (state, { error, payload }) => {
      if (error) {
        return state;
      }
      return {
        ...state,
        loadingCredentials: false,
        elements: payload.data,
      };
    },
    [CAPS.MERCHANTS_CREDENTIALS_POST.LOADING]: state => ({
      ...state,
      generatingCredentials: true,
      userName: null,
      password: null,
    }),
    [CAPS.MERCHANTS_CREDENTIALS_POST]: (state, { error, payload }) => {
      if (error) {
        return state;
      }
      return {
        ...state,
        generatingCredentials: false,
        elements: [...state.elements, payload.data],
        userName: payload.data.username,
        password: payload.data.password,
      };
    },
  },
  init,
);
